import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import { atom, useRecoilState } from "recoil";
import styled from "styled-components";
import { IPayFilter } from "../../../../pages/Pay/PayInfo";
import ConfirmBtn from "../../../Button/ConfirmBtn";
import LineBtn from "../../../Button/LineBtn";
import FilterIcon from "../../../DefaultStyles/FilterIcon";
import Flex from "../../../DefaultStyles/Flex";
import DropDown, { OptionType } from "../../../Filters/DropDown";
import Search from "../../../Filters/Search";
import { PartyInfoFilterContainer } from "../../Party/PartyInfo/PartyInfoFilter";

interface PayInfoFilterProps {
  setFilter: Dispatch<SetStateAction<IPayFilter>>;
  filter: IPayFilter;
  setPage: Dispatch<SetStateAction<number>>;
}

export const payInfoDropdownState = atom<OptionType>({
  key: "payInfoDropdownState",
  default: {
    value: "",
    label: "선택",
  },
});

export const payInfoSearchState = atom<string | undefined>({
  key: "payInfoSearchState",
  default: "",
});

export default function PayInfoFilter({
  setFilter,
  filter,
  setPage,
}: PayInfoFilterProps) {
  const [dropDownValue, setDropDownValue] =
    useRecoilState(payInfoDropdownState);
  const [searchValue, setSearchValue] = useRecoilState<string | undefined>(
    payInfoSearchState
  );

  const [memoDropDownValue, setMemoDropDownValue] = useState<OptionType>({
    value: "",
    label: "적요 선택",
  });

  const options: OptionType[] = [
    { value: "uid", label: "UID" },
    { value: "name", label: "이름" },
    { value: "nickname", label: "닉네임" },
    { value: "phone", label: "전화번호" },
    { value: "partyid", label: "PID" },
  ];

  const memoOptions: OptionType[] = [
    { value: "1", label: "파티 요금 결제" },
    { value: "2", label: "파티 위약금 결제" },
    { value: "3", label: "파티 종료 적립" },
    { value: "4", label: "파티 요금 적립" },
    { value: "5", label: "링키드 머니 인출" },
  ];

  useEffect(() => {
    if (searchValue && searchValue !== "") {
      setFilter({
        ...filter,
        searchValue,
        type: dropDownValue?.value!,
      });
    }
  }, [searchValue]);

  return (
    <PayInfoFilterContainer>
      <Flex gapSize={10}>
        <DropDown
          isDisabled={false}
          setDropDownValue={setDropDownValue}
          dropdownValue={dropDownValue}
          optionList={options}
          boxWidth={180}
        />

        <Search
          placeholder="입력"
          setSearchValue={setSearchValue}
          isDisabled={dropDownValue ? false : true}
          pageResetEvent={() => setPage(0)}
          defaultValue={
            filter.searchValue !== "" ? filter.searchValue : undefined
          }
          inputType={
            dropDownValue?.value === "partyid" ||
            dropDownValue?.value === "phone" ||
            dropDownValue?.value === "uid"
              ? "number"
              : undefined
          }
        />
      </Flex>

      <Flex gapSize={10}>
        <FilterIcon />

        <DropDown
          isDisabled={false}
          setDropDownValue={setMemoDropDownValue}
          dropdownValue={memoDropDownValue}
          optionList={memoOptions}
          boxWidth={180}
        />

        <ConfirmBtn
          btnText="적용"
          btnColor="mint"
          isDisabled={memoDropDownValue?.value === ""}
          btnClickEvent={() => {
            setPage(0);
            setFilter({
              ...filter,
              memo: memoDropDownValue?.value!,
            });
          }}
        />

        <LineBtn
          btnColor="mint"
          btnText="초기화"
          icon="refresh"
          btnHeight={38}
          disabled={memoDropDownValue?.value === ""}
          btnClickEvent={() => {
            setMemoDropDownValue({
              value: "",
              label: "적요 선택",
            });

            setFilter({
              ...filter,
              memo: "",
            });
          }}
        />
      </Flex>
    </PayInfoFilterContainer>
  );
}

const PayInfoFilterContainer = styled(PartyInfoFilterContainer)``;
